module.exports = __webpack_public_path__ + "img/Simplex2.4df867e8.png";